export type SharePlatform = 'copy' | 'email' | 'x' | 'bluesky' | 'reddit' | 'facebook' | 'whatsapp' | 'telegram';

function withUtm(url: string, source: string, medium: string, campaign = 'share'): string {
  try {
    const u = new URL(url);
    const p = u.searchParams;
    p.set('utm_source', source);
    p.set('utm_medium', medium);
    p.set('utm_campaign', campaign);
    u.search = p.toString();
    return u.toString();
  } catch {
    return url;
  }
}

export function buildShareUrls(pageUrl: string, title?: string) {
  const url = pageUrl;
  const text = title || 'Check this out';
  const encoded = encodeURIComponent;
  return {
    copy: withUtm(url, 'copy', 'social'),
    email: `mailto:?subject=${encoded(text)}&body=${encoded(withUtm(url, 'email', 'social'))}`,
    x: `https://twitter.com/intent/tweet?text=${encoded(text)}&url=${encoded(withUtm(url, 'x', 'social'))}`,
    // Bluesky — adult-friendly fediverse-style network. Composer accepts a single
    // `text` param; we put the URL after the title so it renders inline as a card.
    bluesky: `https://bsky.app/intent/compose?text=${encoded(text + ' ' + withUtm(url, 'bluesky', 'social'))}`,
    reddit: `https://www.reddit.com/submit?url=${encoded(withUtm(url, 'reddit', 'social'))}&title=${encoded(text)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encoded(withUtm(url, 'facebook', 'social'))}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encoded(text + ' ' + withUtm(url, 'whatsapp', 'social'))}`,
    // Telegram — heavy on mobile DMs + channels for adult creators.
    telegram: `https://t.me/share/url?url=${encoded(withUtm(url, 'telegram', 'social'))}&text=${encoded(text)}`,
  } as const;
}

